import { Controller } from '@hotwired/stimulus';

export default class NestedFormController extends Controller {
  static targets = ['addLink', 'removeLink', 'template', 'counter', 'fieldsWrapper'];

  connect () {
    this.updatePositions();
    this.refreshCounters();
  }

  addAssociation (event) {
    event.preventDefault();

    // child_index must be unique in nested form. Replacing template child index "NEW_RECORD" with a unique timestamp
    // Replace only first "NEW_RECORD" occurence in attributes, to preserve other nested templates
    const content = this.templateTarget.innerHTML.replace(/(="[^"]*?)NEW_RECORD/g, `$1${new Date().getTime()}`);
    this.addLinkTarget.insertAdjacentHTML('beforebegin', content);

    this.updatePositions();
    this.refreshCounters();

    const fieldsWrapperArray = Array.from(
      this.element.querySelectorAll('div[data-nested-form-target=fieldsWrapper]')
    );
    // Trigger event on window with fieldset in payload so that after add logic
    // can be done in other controller
    const trigger = new CustomEvent('nestedElementAdded', {
      detail: {
        fieldset: fieldsWrapperArray.pop(),
        previousFieldset: fieldsWrapperArray.pop()
      },
    });

    window.dispatchEvent(trigger);
  }

  removeAssociation (event) {
    event.preventDefault();

    const fieldsWrapper = event.currentTarget.closest('[data-nested-form-target=fieldsWrapper]');

    if (fieldsWrapper.dataset.newRecord === 'true') {
      fieldsWrapper.remove();
    } else {
      fieldsWrapper.querySelector("input[name*='_destroy']").value = 1;
      fieldsWrapper.dataset.destroyed = 'true';
      fieldsWrapper.style.display = 'none';
    }

    this.updatePositions();
    this.refreshCounters();

    const trigger = new CustomEvent('nestedElementRemoved')
    window.dispatchEvent(trigger);
  }

  refreshCounters () {
    this.counterTargets.filter((counter) => {
      return counter.closest('[data-nested-form-target=fieldsWrapper]').style.display !== 'none';
    }).forEach((counter, i) => {
      counter.innerHTML = `${counter.dataset.text} ${i + 1}`;
    });
  }

  _countNestedFields () {
    return this.fieldsWrapperTargets.length;
  }

  moveUp(event) {
    event.preventDefault();

    const current = event.currentTarget.closest('[data-nested-form-target="fieldsWrapper"]');
    const siblings = this.fieldsWrapperTargets.filter(el => !this.isDestroyed(el));

    const index = siblings.indexOf(current);
    if (index > 0) {
      const previous = siblings[index - 1];
      current.parentNode.insertBefore(current, previous);
      this.updatePositions();
      this.refreshCounters();
    }
  }

  moveDown(event) {
    event.preventDefault();

    const current = event.currentTarget.closest('[data-nested-form-target="fieldsWrapper"]');
    const siblings = this.fieldsWrapperTargets.filter(el => !this.isDestroyed(el));

    const index = siblings.indexOf(current);
    if (index !== -1 && index < siblings.length - 1) {
      const next = siblings[index + 1];
      current.parentNode.insertBefore(next, current);
      this.updatePositions();
      this.refreshCounters();
    }
  }

  updatePositions() {
    const wrappers = this.fieldsWrapperTargets.filter(el => !this.isDestroyed(el));
    wrappers.forEach((wrapper, index) => {
      const positionInput = wrapper.querySelector('input[name$="[position]"]');
      if (positionInput) positionInput.value = index + 1;
    });

    this.updateMoveButtonsVisibility();
  }

  updateMoveButtonsVisibility() {
    const wrappers = this.fieldsWrapperTargets.filter(w => !this.isDestroyed(w));

    wrappers.forEach((wrapper, index) => {
      const isFirst = index === 0;
      const isLast = index === wrappers.length - 1;

      const moveUpButton = Array.from(wrapper
        .querySelectorAll(".move-up-button"))
        .find(btn => btn.closest('[data-nested-form-target="fieldsWrapper"]') === wrapper);

      const moveDownButton = Array.from(wrapper
        .querySelectorAll(".move-down-button"))
        .find(btn => btn.closest('[data-nested-form-target="fieldsWrapper"]') === wrapper);

      if (moveUpButton) {
        moveUpButton.style.display = isFirst ? "none" : "";
      }

      if (moveDownButton) {
        moveDownButton.style.display = isLast ? "none" : "";
      }
    });
  }

  isDestroyed(wrapper) {
    const destroyInput = wrapper?.querySelector("input[name$='[_destroy]']");
    return destroyInput?.value === "1";
  }
}
